import { Component, OnInit, OnDestroy } from '@angular/core';
import { AdminMenusService } from '../admin-sidebar/admin-menus.service';
import * as $ from 'jquery';
import { ApiserviceService } from '../../apiservice.service';
import { Router } from '@angular/router';
import { AppNotificationService } from '../services/app-notification.service';
import { Subscription } from 'rxjs';


  /**
 *
 * <strong>List of API using</strong>
 * <ol>
 * <li>estapi_assignments_get</li>
 * </ol>
 *
 */
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {
  loader: boolean = true;
  private subs = new Subscription();
  constructor(private readonly menu: AdminMenusService, private readonly api:ApiserviceService, private readonly router: Router, private readonly alert: AppNotificationService) {
  //  this.getAssignments()
    this.menu.setActive('dashboard');
  }
  success(){
    this.loader = false;
  }
  ngOnInit() {
    if(!this.api.user_id && !this.api.city_id){
      this.router.navigateByUrl('/admin/login');
    }
    this.alert.getCount();
  }
  getAssignments(){
    const assignmentSub = this.api.getEmsData('assignments?sort_by=assignment_name&status=1&assigned_to='+this.api.user_id)
    .subscribe({
      next:(data:any) => {
      },
      error:err => {
      }
    })
    this.subs.add(assignmentSub);
  }
  ngAfterViewInit(){
    $(document).ready(function () {
      $('#frame').on('load', function () {

      });
  });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
